"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WELCOME_LOBBY_HELP_DESK_CONFIG = exports.HUBSPOT_PLAN_FORM_ID = exports.HUBSPOT_PLAN_PORTAL_ID = exports.DEFAULT_AI_TOKENS = exports.DEFAULT_TICKETS = void 0;
exports.DEFAULT_TICKETS = 25;
exports.DEFAULT_AI_TOKENS = 3;
exports.HUBSPOT_PLAN_PORTAL_ID = '7747565';
exports.HUBSPOT_PLAN_FORM_ID = '7ff9d979-0585-4dab-8537-59a57033cd55';
exports.WELCOME_LOBBY_HELP_DESK_CONFIG = {
    'https://poormanvr.s3.us-east-2.amazonaws.com/betterDMV-maps/_Welcome+Lobby+A.jpeg': {
        center: {
            x: 311,
            y: 135.4,
        },
        radius: 33.5,
    },
    'https://poormanvr.s3.us-east-2.amazonaws.com/betterDMV-maps/_Welcome+Lobby+B.jpeg': {
        center: {
            x: 321.9,
            y: 152.4,
        },
        radius: 33.5,
    },
    'https://poormanvr.s3.us-east-2.amazonaws.com/betterDMV-maps/_Welcome+Lobby+C.jpeg': {
        center: {
            x: 347.2,
            y: 121.6,
        },
        radius: 33.5,
    },
    'https://poormanvr.s3.us-east-2.amazonaws.com/betterDMV-maps/_Welcome+Lobby+D.png': {
        center: {
            x: 363.6,
            y: 146.2,
        },
        radius: 33.5,
    },
    'https://poormanvr.s3.us-east-2.amazonaws.com/betterDMV-maps/_Welcome+Lobby+E.png': {
        center: {
            x: 354.2,
            y: 196,
        },
        radius: 33.5,
    },
};
